import React from "react";
import Infrastructure from "./vdi";
import Hero from "./hero";
import Cards from "./Cards";


function Index() {
    return (
        <div>
            <Hero />
            <Infrastructure />
            <Cards />
        </div>
    );
}

export default Index;